import { createContext, useState } from "react";


const DepositModalContext = createContext({
  showModal: function () {},
  hideModal: function () {},
});

export const DepositModalContextProvider = (props) => {
  const [activeModal, setActiveModal] = useState(false);
  const [activeModalDis, setActiveModalDis] = useState(false);

  const handleShowModal = () => {
    setActiveModal(true);
  };

  const handleHideModal = () => {
    setActiveModal(false);
  };

  const handleShowModalDis = () => {
    setActiveModalDis(true);
  };

  const handleHideModalDis = () => {
    setActiveModalDis(false);
  };
  
  const context = {
    isDepositModalOpen: activeModal,
    activeModalDis:activeModalDis,
    showModal: handleShowModal,
    hideModal: handleHideModal,
    showModalDis: handleShowModalDis,
    hideModalDis: handleHideModalDis,
  };
  return (
    <DepositModalContext.Provider value={context}>
      {props.children}
    </DepositModalContext.Provider>
  );
};

export default DepositModalContext;
